import {Component, Input} from '@angular/core';
import {LeagueCompetitor, MatchStatus} from "@model";
import {TranslocoService} from "@ngneat/transloco";
import {NgbActiveModal} from "@ng-bootstrap/ng-bootstrap";
import {AbstractComponent} from "../../abstract.component";

@Component({
  selector: 'app-competitor-details-modal',
  templateUrl: './competitor-details-modal.component.html',
  styleUrl: './competitor-details-modal.component.scss',
  standalone: false,
})
export class CompetitorDetailsModalComponent extends AbstractComponent{
  @Input() competitor?: LeagueCompetitor;
  @Input() raceNames: Map<number, string> = new Map<number, string>();

  constructor(public translocoService: TranslocoService, public activeModal: NgbActiveModal
  ) {
    super();
  }

  ngOnInit() {
  }

  onClose(): void {
    this.activeModal.dismiss();
  }

  protected readonly MatchStatus = MatchStatus;

}
